import React, { useState, useEffect } from "react";
import { firestore } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

function ResultsPage() {
  const [results, setResults] = useState([]);

  // Firebase'den tasarruf sonuçlarını çekme
  useEffect(() => {
    const fetchResults = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, "bills"));
        const resultsArray = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // Elektrik ve su tasarruf yüzdesi verilerini al
          const electricSavings = data.electricSavings || 0;
          const waterSavings = data.waterSavings || 0;

          // Toplam tasarruf yüzdesi (ortalama)
          const totalSavings = (electricSavings + waterSavings) / 2;

          resultsArray.push({
            studentName: data.studentName,
            electricSavings,
            waterSavings,
            totalSavings,
          });
        });

        // Sonuçları sıralama
        resultsArray.sort((a, b) => b.totalSavings - a.totalSavings); // En yüksek tasarrufu ilk sırada
        setResults(resultsArray);
      } catch (error) {
        console.error("Veriler alınırken hata oluştu:", error);
      }
    };

    fetchResults();
  }, []);

  return (
    <div>
      <h2>Tasarruf Sonuçları</h2>
      <table>
        <thead>
          <tr>
            <th>Öğrenci Adı</th>
            <th>Elektrik Tasarrufu (%)</th>
            <th>Su Tasarrufu (%)</th>
            <th>Toplam Tasarruf (%)</th>
          </tr>
        </thead>
        <tbody>
          {results.map((result, index) => (
            <tr key={index}>
              <td>{result.studentName}</td>
              <td>{result.electricSavings.toFixed(2)}%</td>
              <td>{result.waterSavings.toFixed(2)}%</td>
              <td>{result.totalSavings.toFixed(2)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ResultsPage;
